
import { FormProcessor } from '@/api/forms/processor';
import {
  Snippet,
  DefaultSnippet,
} from '@/api/snippets/snippet';
import { SnippetShow } from '@/api/snippets/show';
import Vue from 'vue';

export default Vue.component('snippets-form', {
  props: ['snippetId'],
  data() {
    return {
      id: -1 as number,
      isNew: false,
      snippetData: DefaultSnippet() as Snippet,
      processor: new FormProcessor()
    }
  },
  methods: {
    loadForm() {
      if (!this.$route.params.id) return;

      SnippetShow.getData(this.id).then((response) => {
        this.snippetData = SnippetShow.parseResponse(response);
      });
    },
    deleteForm() {
      if (this.processor === null || !this.processor.shouldDelete() || !this.superAdminMode) {
        return;
      }
      this.processor.deleteData(SnippetShow, this.id);
    },
    saveForm() {
      this.snippetData.id = this.id;
      if (this.processor === null || !this.processor.shouldSave()) {
        return;
      }
      this.processor.saveData(
        SnippetShow,
        this.snippetData,
        this.$refs.submitForm,
      );
    },
    undoForm() {
      if (this.processor === null || !this.processor.undoForm()) {
        return;
      }
      this.loadForm();
    },
    handleNew() {
      this.id = -1;
      this.isNew = true;
      this.processor.setParams(
        this.id,
        this.snippetData,
        DefaultSnippet(),
        this.updateCallback,
        this.saveCallback,
        this.deleteCallback,
      );
      this.processor.readOnly = false;
    },
    resetForm() {
      const id = this.$route.params.id;
      if (!id || id === 'new') {
        this.handleNew();
        return;
      }
      this.id = Number(id);
      if (this.id <= 0) {
        return;
      }
      this.processor.setParams(
        this.id,
        this.snippetData,
        DefaultSnippet(),
        this.updateCallback,
        this.saveCallback,
        this.deleteCallback,
      );
      this.loadForm();
    },

    deleteCallback() {
      this.$router.replace({ name: 'snippets' });
    },
    saveCallback(data: any) {
      if (this.isNew && data.id) {
        this.id = data.id;
        this.snippetData.id = data.id;
        this.isNew = false;
        history.pushState({}, '', `/snippets/${data.id}`);
      }
      this.loadForm();
    },
    updateCallback(formData: Snippet) {
      this.snippetData = formData;
    },
  },
  mounted() {
    this.id = Number(this.$route.params.id)

    this.resetForm();
  },

  computed: {
    superAdminMode: function () {
      let params = new URLSearchParams(document.location.search);
      return params.get("sam") === 'true';
    }
  }

})
